import { useMsal } from "@azure/msal-react";
import { CssBaseline } from "@mui/material";
import { SdxAdmin, SdxAdminProps } from "@sodexo/admin-module-react";
import { useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import { RouterProvider } from "react-router-dom";
import useAsyncEffect from "use-async-effect";
import "./App.css";
import { router } from "./routes/routes";
import AppInsightHOC from "./shared_components/AppInsightHOC";
import CenteredLoading from "./shared_components/CenteredLoading/CenteredLoading";

export const SDX_ADMIN_PROJECT_ID = process.env.SDX_ADMIN_PROJECT_ID || "";

export default function App() {
  const { instance, accounts } = useMsal();
  const [idToken, setIdToken] = useState("");

  useAsyncEffect(async () => {
    if (accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
      const token = await instance.acquireTokenSilent({ scopes: [] });
      setIdToken(token.idToken);
    }
  }, [accounts]);

  if (!idToken) {
    return <CenteredLoading />;
  } else {
    return (
      <SdxAdmin
        projectId={SDX_ADMIN_PROJECT_ID}
        clientId={process.env.AAD_CLIENT_ID}
        server={getAdminModuleServer()}
        idToken={idToken}
      >
        <AppInsightHOC>
          <>
            <CssBaseline />
            {/*<ReactQueryDevtools initialIsOpen={true} />*/}
            <RouterProvider router={router} />
          </>
        </AppInsightHOC>
      </SdxAdmin>
    );
  }
}

function getAdminModuleServer(): SdxAdminProps["server"] {
  switch (process.env.NODE_ENV as string) {
    case "local":
      return "local";
    case "development":
      return "dev_sdx";
    case "uat":
      return "dev_sdx";
    default:
      return "prod_sdx";
  }
}
